module.exports = __webpack_public_path__ + "static/media/thumbnail.292b41f7.jpg";